import HealthScorePage from "./index";

export default function HealthScorePageExamples() {
  return <HealthScorePage />;
}
